export function AppleLogoIcon({ className = "w-8 h-8" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M17.564 12.72c-.03-3.03 2.475-4.484 2.588-4.556-1.408-2.06-3.6-2.343-4.383-2.376-1.866-.188-3.638 1.098-4.585 1.098-.949 0-2.408-1.07-3.958-1.04-2.036.03-3.914 1.185-4.965 3.005-2.117 3.67-.541 9.106 1.517 12.086 1.005 1.458 2.204 3.096 3.78 3.037 1.516-.06 2.09-.982 3.923-.982 1.832 0 2.348.982 3.955.951 1.632-.03 2.665-1.487 3.663-2.951 1.153-1.694 1.628-3.337 1.656-3.42-.036-.014-3.17-1.214-3.191-4.815zM14.512 3.9c.837-1.017 1.402-2.43 1.248-3.836-1.207.05-2.667.804-3.531 1.82-.777.9-1.456 2.336-1.273 3.72 1.345.104 2.72-.685 3.556-1.703z" />
    </svg>
  );
}

export function GooglePlayIcon({ className = "w-7 h-7" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 512 512"
      aria-hidden="true"
    >
      <path
        d="M325.3 234.3L104.3 50.4c-9.9-8.2-24.4-5.5-30.6 5.7l229.6 178.2z"
        fill="#32BBFF"
      />
      <path
        d="M73.7 56.2c-2 3.6-3.2 7.8-3.2 12.5v374.6c0 4.7 1.2 8.9 3.2 12.5l229.6-199.8L73.7 56.2z"
        fill="#32BBFF"
      />
      <path
        d="M303.3 234.3L73.7 56.2c-1.6 2.9-2.6 6.2-2.9 9.7l229.9 172.3 2.6-3.9z"
        fill="#32BBFF"
      />
      <path
        d="M429.6 213.4L364 175.4l-70.3 60.6 70.3 60.6 65.6-38c14.4-8.3 14.4-30.9 0-39.2z"
        fill="#FFBF00"
      />
      <path
        d="M74 456.1c6.4 11 20.6 13.5 30.4 5.4l223.5-186.9-24.6-24.6L74 456.1z"
        fill="#FF4B4B"
      />
      <path
        d="M104.4 50.4L327.8 237.3l-24.6 24.6L74 56.2c6.4-11 20.6-13.5 30.4-5.8z"
        fill="#00F076"
      />
    </svg>
  );
}
